module.exports = __webpack_public_path__ + "img/svg/decrement-arrow.2a0456e3a343494fcdb65c7c1d4fc892.svg";